<div class="flex items-center gap-2 group">
  @if (isSubprocess()) {
    <i
      class="ph ph-tree-structure text-gray-500"
      pTooltip="Subprocess"
    ></i>
  }
  <span class="flex items-center">
    <div class="truncate w-14 text-black">
      {{ uuid() }}
    </div>
    <flx-icon
      [name]="!copied() ? 'copy' : 'circle-check'"
      [class.text-green-300]="copied()"
      [cdkCopyToClipboard]="uuid()"
      (cdkCopyToClipboardCopied)="copyUuidSuccess()"
      class="cursor-pointer"
      clickStopPropagation
    ></flx-icon>
  </span>
</div>
